import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import type { ChatCitationType, InteractionType , Chat  } from '@trinity/chat';
import { InteractionTypesMap } from '@trinity/chat';
import { OpenCrmNoteContext, SetOpenCitationContext } from '@trinity/chat-components/components/Chat/context';
import { MessageCitation, Header, Title } from './Citation';
import { StyledActionButton } from './Citation.Toggle';

type Props = {
  interactionType: InteractionType;
  items: Chat.Citation<ChatCitationType.CrmNote>[];
};

export const InteractionCitations = ({ interactionType, items }: Props) => {

  const [isOpen, setIsOpen] = useState(false);

  const openCitation = useContext(OpenCrmNoteContext);
  const setOpenCitation = useContext(SetOpenCitationContext);

  const isChildCitationOpen = useMemo(() => {
    return items.some(s => s.id === openCitation);
  }, [items, openCitation]);

  useEffect(() => {
    if (isChildCitationOpen) {
      setIsOpen(true);
    }
  }, [isChildCitationOpen]);

  const toggleManuallyOpen = useCallback(() => {
    setIsOpen(s => !s);
    if (isOpen && isChildCitationOpen) {
      setOpenCitation(null);
    }
  }, [isChildCitationOpen, isOpen, setOpenCitation]);

  return (
    <div>
      <Header onClick={toggleManuallyOpen}>
        <Title>{InteractionTypesMap[interactionType]}s ({items.length})</Title>
        <StyledActionButton>
          [{isOpen ? 'Hide' : 'Show'} All]
        </StyledActionButton>
      </Header>
      {isOpen && (
        <>
          {items.map((item, i) => (
            <MessageCitation key={i} item={item} />
          ))}
        </>
      )}
    </div>
  );
};